var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"px-4 py-1 border rounded",class:_vm.statusClass},[_vm._v(" Статус ЛМСЗ: "+_vm._s(_vm.statusName)+" ")])}
var staticRenderFns = []

export { render, staticRenderFns }